import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also store token in memory + localStorage as fallback (some browsers block 3rd-party cookies)
let accessToken = null;
try {
  accessToken = localStorage.getItem("cuidar_access_token");
} catch (_) {}

export function setAccessToken(token) {
  accessToken = token || null;
  try {
    if (token) localStorage.setItem("cuidar_access_token", token);
    else localStorage.removeItem("cuidar_access_token");
  } catch (_) {}
}

api.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
